export default {
      id: "btn-shape--white-usage",
      viewBox: "0 0 55 54",
      url: "../../assets/" + "sprite.svg#btn-shape--white-usage",
      toString: function () {
        return this.url;
      }
    }